import { binarySelectOptions } from '@application/utils';
import { FrequencyType, LastVisitType, TemperType, YesNoUnknownStatus } from '@gql/graphql';
import type { SelectOption } from '@presentation/components';
import { Button, InputLabel, InputRadioField, InputWrapper } from '@presentation/components';
import type { BookingPageProps } from '@presentation/pages';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from '../styled';

export const BookingPageGroomerForm: FC<BookingPageProps> = (props) => {
  const { onNextClick, onPreviousClick } = props;
  const { translate } = useTranslation();

  return (
    <>
      <Styled.BookingSubtitle>{translate('booking.steps.moreInfo')}</Styled.BookingSubtitle>
      <InputWrapper>
        <InputLabel>{translate('common.inputs.recentlyAdopted.label')}</InputLabel>
        <InputRadioField<boolean>
          name="animalRecentlyAdopted"
          options={binarySelectOptions(translate)}
        />
      </InputWrapper>

      <InputWrapper>
        <InputLabel>{translate('common.inputs.firstVisit.label')}</InputLabel>
        <InputRadioField<boolean>
          name="animalFirstTimeAtGroomer"
          options={binarySelectOptions(translate)}
        />
      </InputWrapper>

      <InputWrapper>
        <InputLabel>{translate('common.inputs.character.label').split(' (')[0]}</InputLabel>
        <InputRadioField<TemperType>
          name="animalTemper"
          options={Object.keys(TemperType).map(
            (x) =>
              ({
                value: x,
                label: translate(`enum.temperType.${x}`),
              } as SelectOption<TemperType>),
          )}
        />
      </InputWrapper>

      <InputWrapper>
        <InputLabel>{translate('common.inputs.coatCondition.label')}</InputLabel>
        <InputRadioField<YesNoUnknownStatus>
          name="animalHasKnottedFur"
          options={[YesNoUnknownStatus.YES, YesNoUnknownStatus.UNKNOWN, YesNoUnknownStatus.NO].map(
            (x) =>
              ({
                value: x,
                label: translate(`enum.yesNoUnknownStatus.${x}`),
              } as SelectOption<YesNoUnknownStatus>),
          )}
        />
      </InputWrapper>

      <InputWrapper>
        <InputLabel>{translate('common.inputs.lastVisit.label')}</InputLabel>
        <InputRadioField<LastVisitType>
          name="animalLastVisit"
          options={Object.keys(LastVisitType).map(
            (x) =>
              ({
                value: x,
                label: translate(`enum.lastVisitType.${x}`),
              } as SelectOption<LastVisitType>),
          )}
        />
      </InputWrapper>

      <InputWrapper>
        <InputLabel>{translate('common.inputs.brushing.label')}</InputLabel>
        <InputRadioField<FrequencyType>
          name="animalBrushingFrequency"
          options={[FrequencyType.RARELY, FrequencyType.SOMETIMES, FrequencyType.REGULARLY].map(
            (x) =>
              ({
                value: x,
                label: translate(`enum.frequencyType.${x}`),
              } as SelectOption<FrequencyType>),
          )}
        />
      </InputWrapper>

      <InputWrapper>
        <InputWrapper split>
          <Button color="blue" outlined size="large" onClick={onPreviousClick}>
            {translate('common.buttons.previous')}
          </Button>
        </InputWrapper>
        <InputWrapper split last>
          <Button color="blue" size="large" onClick={onNextClick}>
            {translate('common.buttons.next')}
          </Button>
        </InputWrapper>
      </InputWrapper>
    </>
  );
};
